import {useState}       from 'react';
import {Container, TableRow, TableHead, TableContainer, TableCell, TableBody, Table, IconButton} from '@material-ui/core';
import {connect}        from 'react-redux';
// Redux
import {changeView} from '../../redux/actions/Menu';
import {getVehicles, updateVehicles} from '../../redux/actions/Vehicles';
// Components
import LoadingData      from '../global/LoadingData';
import Pagination       from '../global/ButtonsPagination';
// Values
import {Ic_edit, StateView, stateData} from '../../values';
// Styles
import {useStyles}          from '../../style';
// Api
import {getData}        from '../../utils/vehicles';

const Tables = ({data, status, token, records, changeView, getVehicles, updateVehicles}) => {
    const classes = useStyles()
    const [page,setPage]    = useState(1)

    const edit = (item) => {
        changeView(StateView.state3)
        updateVehicles(item)
    }

    const GetData = async(page) =>{
        const res = await getData(token, `?Page=${page}`)
        getVehicles(res.data)
        window.scrollTo(0, 0)
    }
    const changePage = (e,v) =>{
        setPage(v)
        GetData(v)
    }
    return (
        <div style={{position:'relative'}}>
            {
                status===stateData.state2?
                    <Container maxWidth="xl">
                        <TableContainer style={{background:'#fff'}}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow style={{background:'#132327', height:50}}>
                                        {
                                            ['Modelo', 'Empresa', 'Ciudad', 'Año', 'Placas', 'Editar'].map((item, index) =>
                                                <TableCell align="center" key={index} className={classes.table_title3} style={{fontFamily:'bold', color:'#fff'}}> {item} </TableCell>
                                            )
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        data&&
                                        data.map((item, index) =>(
                                            <TableRow key={index} style={{borderBottom:`1px solid #f3f4f7`}}>
                                                <TableCell align="center" className={classes.table_text3} style={{fontFamily:'regular'}}>{item.Model}</TableCell>
                                                <TableCell align="center" className={classes.table_text3} style={{fontFamily:'regular'}}>{item.Company}</TableCell>
                                                <TableCell align="center" className={classes.table_text2} style={{fontFamily:'regular'}}><span style={{fontWeight:700}}>{item.City}</span></TableCell>
                                                <TableCell align="center" className={classes.table_text2} style={{fontFamily:'regular'}}><span style={{fontWeight:700}}>{item.Year}</span></TableCell>
                                                <TableCell align="center" className={classes.table_text3} style={{fontFamily:'regular'}}>{item.Plates}</TableCell>
                                                <TableCell align="center" className={classes.table_text3}>
                                                    <IconButton onClick={() => edit(item)}>
                                                        <img alt="ic_edit" src={Ic_edit} />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Pagination records={records} page={page} changePage={changePage} />
                    </Container>
                :
                    <LoadingData />
            }
        </div>
    );
};

const mapStateToProps = state =>({
    data:       state.Vehicles.vehicles,
    status:     state.Vehicles.status,
    token:      state.Panel.token,
    records:    state.Vehicles.records
})

export default connect(mapStateToProps, {changeView, getVehicles, updateVehicles})(Tables);
